// useChatFaq - 后台薄包装层
//
// 🔁 2026-10-27：通用逻辑已迁入 @huyu/core（后台 / AI 前台共用一份源码）。
//   图标池由 aiRuntime 注册（Element Plus 图标），内核只负责数据与发送。
import { useChatFaq as useCoreChatFaq } from '@huyu/core/vue'
import { ensureAiRuntime } from './aiRuntime'

export function useChatFaq(options = {}) {
  ensureAiRuntime()
  return useCoreChatFaq(options)
}
